import React from 'react'

export default props => (
  <svg viewBox="0 0 18 14" {...props}>
    <path d="M9,4.97171815 C7.896,4.97171815 7,5.86265005 7,6.96040542 C7,8.05915513 7.896,8.94909268 9,8.94909268 C10.105,8.94909268 11,8.05915513 11,6.96040542 C11,5.86265005 10.105,4.97171815 9,4.97171815 M9,11.9321236 C6.628,11.9321236 4.221,10.1343503 2.297,6.96040542 C4.221,3.78646055 6.628,1.98868726 9,1.98868726 C11.372,1.98868726 13.779,3.78646055 15.703,6.96040542 C13.779,10.1343503 11.372,11.9321236 9,11.9321236 M9,0 C5.738,0 2.475,2.31980369 0,6.96040542 L0,6.96040542 C2.475,11.6010071 5.738,13.9208108 9,13.9208108 C12.263,13.9208108 15.525,11.6010071 18,6.96040542 L18,6.96040542 C15.525,2.31980369 12.263,0 9,0" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/view.js